export class LooplaySDKError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'LooplaySDKError';
  }
}

export class NotInitializedError extends LooplaySDKError {
  constructor() {
    super('LooplaySDK not initialized. Call init({ gameId }) first.');
    this.name = 'NotInitializedError';
  }
}

export class MissingBaseUrlError extends LooplaySDKError {
  constructor() {
    super('Missing baseUrl. Provide `baseUrl` to enable HTTP integration.');
    this.name = 'MissingBaseUrlError';
  }
}

export class MissingAuthError extends LooplaySDKError {
  constructor() {
    super('Missing auth. Provide `auth` options to enable user login/session.');
    this.name = 'MissingAuthError';
  }
}

export class NotAuthenticatedError extends LooplaySDKError {
  constructor() {
    super('Not authenticated. Login is required for this operation.');
    this.name = 'NotAuthenticatedError';
  }
}
